import { combineReducers } from 'redux'
import animationId from './animationId'
import snapshot from './snapshot'
import timer from './timer'
import view from './view'

const reducers = combineReducers({
  animationId,
  snapshot,
  timer,
  view
})

export default reducers



// WEBPACK FOOTER //
// ./src/ducks/index.ts